module.exports = __webpack_public_path__ + "static/media/abc-logo.95460902.png";